import AdminAddPasein from "../../components/AdminInvoiceMedical/InvoiceMedicalAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
